import type { BankingConnection } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  connection: BankingConnection;
};

export function createConnectBankAccountCompleted(
  props: Props & { id?: string },
): SmbActionDefinition {
  const { connection, id = `connect-bank:done:${connection.id}` } = props;
  const institution = connection.institutionName.trim() || "Bank account";
  return {
    id,
    category: "budget",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="budget"
        badge="Budget"
        title={`${institution} connected`}
        details={{
          title: "Bank account connected",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">{institution}</p>
              <p className="opacity-70">
                We'll use the linked account to verify cash flow automatically — no statements to
                upload.
              </p>
            </div>
          ),
        }}
      />
    ),
  };
}
